import { ClockIcon, InformationCircleIcon } from '@heroicons/react/24/outline';

interface Props {
  countdownLabel: string;
  timedOut: boolean;
  onCheckAgain: () => void;
  onDone: () => void;
  compact?: boolean;
}

export function DuitNowApprovalPendingScreen({
  countdownLabel,
  timedOut,
  onCheckAgain,
  onDone,
  compact
}: Readonly<Props>) {
  return (
    <div
      className={`flex w-full max-w-md flex-col items-center text-center ${
        // `compact` only renders inside the home dialog (`AddPaymentMethodDialog`'s
        // `DialogDuitNowApproval`), whose `DialogContent` already has its own `p-6` — adding
        // this screen's own `px-6` on top double-pads to ~48px there. The
        // standalone (non-compact) layout has no host padding, so it keeps `px-6`.
        compact ? 'py-4' : 'mt-24 px-6'
      }`}
    >
      <div className="flex h-24 w-24 items-center justify-center rounded-full bg-[#F6EAD9]">
        <ClockIcon className="h-12 w-12 text-[#D19643]" />
      </div>
      <h1 className="mt-6 text-2xl font-bold text-black">
        Approval request sent
      </h1>
      <p className="mt-3 text-base text-[#5B5959]">
        Open your banking app or internet banking to review and approve the
        AutoDebit request.
      </p>
      <span className="mt-8 inline-flex items-center gap-2 rounded-full bg-[#F6EAD9] px-4 py-1.5 text-sm font-medium text-[#7A4E0E]">
        <span className="h-2 w-2 rounded-full bg-[#D19643]" />
        {timedOut ? 'Still waiting for approval' : 'Waiting for approval'}
      </span>
      {timedOut ? (
        <>
          <div className="mt-6 flex w-full items-start gap-3 rounded-2xl border border-[#E5E7EB] bg-white p-4 text-left">
            <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-[#EEF1F6]">
              <InformationCircleIcon className="h-5 w-5 text-[#5B6577]" />
            </div>
            <div>
              <p className="text-sm font-semibold text-[#1F2937]">Note</p>
              <p className="mt-1 text-sm text-[#5B5959]">
                Your DuitNow AutoDebit will be activated automatically when you
                approve in your bank app.
              </p>
            </div>
          </div>
          <div className="mt-6 flex gap-3">
            <button
              type="button"
              onClick={onCheckAgain}
              className="rounded-full border border-[#5CB891] px-6 py-2 font-semibold text-[#5CB891]"
            >
              Check again
            </button>
            <button
              type="button"
              onClick={onDone}
              className="rounded-full bg-[#5CB891] px-6 py-2 font-semibold text-white hover:bg-[#4aa07c]"
            >
              Done
            </button>
          </div>
        </>
      ) : (
        <p className="mt-4 text-base text-[#5B5959]">
          Estimated time for confirmation:{' '}
          <span className="font-medium text-[#C62828]">{countdownLabel}</span>
        </p>
      )}
    </div>
  );
}
